import React from "react";
import * as theme from "../theme";

export default function Heading2(props) {
  const text = props.text;
  return (
    <div
      style={{
        fontFamily: "GibsonSemiBd",
        fontSize: "min(max(8px,2rem),1.5vw)",
        color: theme.COLORS.primary_navyblue,
      }}
    >
      {text}
    </div>
  );
}
